export default "__VITE_ASSET__laaA_5kE__"